import { setBypassMaintenance } from "@/storage/maintenance/maintenanceSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
export const LoginTest = () => {
    const dispatch = useDispatch();
  
    useEffect(() => {
      dispatch(setBypassMaintenance(true))
    }, [dispatch])
  
    return <Navigate to="/login" />
}
  
